// Workers.js - list of staff members ("Employés"). The Équipe sidebar
// section only had "Nv Employé" (create) with no way to see who already
// exists - this fills that gap.
import React, { useEffect, useState } from "react";
import "../Stock/Stock.css";
import { ToastContainer, toast } from "react-toastify";
import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
} from "@mui/material";
import { userRequest } from "../../RequestMethods";

const Workers = () => {
  const [workers, setWorkers] = useState([]);
  const [loading, setLoading] = useState(true);
  const [search, setSearch] = useState("");

  const fetchWorkers = async () => {
    try {
      setLoading(true);
      const res = await userRequest.get("workers");
      setWorkers(res.data.workers || []);
    } catch (err) {
      toast.error(err?.response?.data?.message || "Erreur lors du chargement des employés.");
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => { fetchWorkers(); }, []);

  const handleDelete = async (worker) => {
    if (!window.confirm(`Supprimer ${worker.name} ${worker.surname} ?`)) return;
    try {
      await userRequest.delete(`workers/${worker._id}`);
      toast.success("Employé supprimé.");
      fetchWorkers();
    } catch (err) {
      toast.error(err?.response?.data?.error || err?.response?.data?.message || "Erreur lors de la suppression.");
    }
  };

  const visible = workers.filter((w) => {
    if (!search.trim()) return true;
    const q = search.toLowerCase();
    return (
      w.name?.toLowerCase().includes(q) ||
      w.surname?.toLowerCase().includes(q) ||
      w.email?.toLowerCase().includes(q)
    );
  });

  return (
    <div className="Stock">
      <h1>Employés</h1>

      <section className="stock-section">
        <div className="stock-filters">
          <input
            type="text" placeholder="Rechercher un employé..."
            value={search} onChange={(e) => setSearch(e.target.value)}
          />
        </div>

        {loading ? (
          <div className="loading-container"><div className="loading-spinner-custom"></div></div>
        ) : (
          <TableContainer component={Paper} className="stock-table-container">
            <Table>
              <TableHead>
                <TableRow className="table-header">
                  <TableCell sx={{ fontWeight: "bold" }}>Nom</TableCell>
                  <TableCell>Email</TableCell>
                  <TableCell>Téléphone</TableCell>
                  <TableCell>Rôle</TableCell>
                  <TableCell>Statut</TableCell>
                  <TableCell>Actions</TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {visible.length === 0 && (
                  <TableRow>
                    <TableCell colSpan={6} align="center">Aucun employé trouvé.</TableCell>
                  </TableRow>
                )}
                {visible.map((w) => (
                  <TableRow key={w._id}>
                    <TableCell>
                      {w.name} {w.surname}
                      {w.isAdmin && <span className="badge movement-correction" style={{ marginLeft: "8px" }}>Admin</span>}
                    </TableCell>
                    <TableCell>{w.email}</TableCell>
                    <TableCell>{w.number || "—"}</TableCell>
                    <TableCell>{w.roleId?.name || "—"}</TableCell>
                    <TableCell>
                      <span className={`badge ${w.isActive !== false ? "movement-in" : "movement-out"}`}>
                        {w.isActive !== false ? "Actif" : "Inactif"}
                      </span>
                    </TableCell>
                    <TableCell>
                      {w.isAdmin ? (
                        <span className="field-note">Super Admin — protégé</span>
                      ) : (
                        <button className="action-icon-btn btn-delete" onClick={() => handleDelete(w)}>
                          Supprimer
                        </button>
                      )}
                    </TableCell>
                  </TableRow>
                ))}
              </TableBody>
            </Table>
          </TableContainer>
        )}
      </section>

      <ToastContainer position="top-right" />
    </div>
  );
};

export default Workers;
